module.exports = __webpack_public_path__ + "img/JabarJamal-SardamiGryan.bff89cc6.jpg";